module.exports = require("./ff-Latn-GH.d.ts");